import { GET_USER_WINES } from '../constants/wines';

export default (state = [], action) => {
  switch (action.type) {
    case GET_USER_WINES:
      return [...state, ...action.payload];
    default:
      return state;
  }
};
